import { Collapse as AntdCollapse, List } from 'antd';
import styled from 'styled-components';

const { Panel: AntdPanel } = AntdCollapse;

export const Collapse = styled(AntdCollapse)`
  background: var(--white-100);

  .ant-collapse-header {
    padding: var(--spacing-02) var(--spacing-07);
  }
`;

export const ListItem = styled(List.Item)`
  border-bottom: 0px;
  border-top: 1px solid var(--gray-20);
  margin-left: var(--spacing-05);
  padding-left: var(--spacing-05);
  display: block;
`;

export const Panel = styled(AntdPanel)`
  &&& {
    border: none;
  }
`;
